import { Loader2, ServerCrash } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function WaitingBackend({ error }: { error?: unknown }) {
  const message = error instanceof Error ? error.message : null;
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        {message ? (
          <>
            <ServerCrash className="h-8 w-8 text-muted-foreground" />
            <div>
              <p className="font-medium">Aguardando backend</p>
              <p className="mt-1 max-w-sm text-sm text-muted-foreground">{message}</p>
            </div>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            <p className="text-sm text-muted-foreground">Conectando ao servidor...</p>
          </>
        )}
      </CardContent>
    </Card>
  );
}
